/**
 * Climbing disciplines supported by the platform, and the default a gym gets
 * when its `disciplines` field is missing or empty — the ONE copy both the
 * client and the two Cloud Functions packages run.
 *
 * The default used to live in five places (the client constants, three
 * `apps/functions/shared` modules and the e-mail package's route-points
 * resolver), each spelling `["boulder"]` by hand. They agreed, but nothing
 * held them to it; a gym with no `disciplines` field is priced and levelled
 * off this default on every side, so a drift would have been a silent
 * cross-side mismatch in points.
 */
export const DISCIPLINES = {
  BOULDER: "boulder",
  LEAD: "lead",
};

export const DEFAULT_DISCIPLINES = [DISCIPLINES.BOULDER];
